"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var items = [
    { form_id: "enrollment_packet", title: "Enrollment Packet Information" },
    { form_id: "nursing_enrollment_packet", title: "Nursing Enrollment Packet Information" },
    { form_id: "test_sample", title: "Sample" },
    { form_id: "signature_certificate", title: "Signature Certificate" },
    { form_id: "enrollment_agreement", title: "Enrollment Agreement Master" },
    { form_id: "enrollment_agreement_nursing", title: "Enrollment Agreement Master - Nursing" },
    { form_id: "sample_redux", title: "Sample Redux" },
    { form_id: "asher_enrollment_agreement", title: "Asher Enrollment Agreement" },
    { form_id: "asher_enrollment_agreement_transfer", title: "Asher Enrollment Agreement Transfer" },
    { form_id: "asher_attendance_contract", title: "Asher Attendance Contract" },
    { form_id: "asher_school_performance", title: "Asher School Performance" },
    {
        form_id: "asher_electronic_notification_authorization",
        title: "Asher Electronic Notification Authorization"
    },
    { form_id: "ferpa_waiver", title: "Ferpa Waiver" },
    { form_id: "tour_receipt", title: "Tour Receipt" },
    { form_id: "scholarship", title: "Scholarship Policy" },
    { form_id: "program_change", title: "Program Change Addendum" },
    { form_id: "diploma_request", title: "Diploma Request" },
    { form_id: "statistics", title: "Student Statistics" },
    {
        form_id: "asher_record_previous_education",
        title: "Asher Record Previous Education and Training"
    },
    { form_id: "asher_book_computer_opt_out", title: "Asher Book Computer opt out" },
    { form_id: "asher_book_disclosure", title: "Asher Book Disclosure" },
    { form_id: "asher_student_performance", title: "Asher Student Performance" },
    { form_id: "asher_pharmacy_technician", title: "Asher Pharmacy Technician" },
    { form_id: "asher_college_certification", title: "Asher College Certification" },
    { form_id: "asher_test_pass_assurance", title: "Asher Test pass assurance" },
    { form_id: "asher_student_performance", title: "Asher Student Performance" },
    { form_id: "w_9s", title: "W-9S form" },
    { form_id: "dress_code", title: "Asher Dress Code" },
    { form_id: "asher_consent_release_information", title: "Asher Consent Release Information" },
    { form_id: "enrollment_package", title: "Asher Enrollment Package" },
    { form_id: "accounting_upgrade", title: "Asher Accounting Upgrade / Downgrade Balance Sheet" },
    { form_id: "asher_enrollment_transfer_package", title: "Asher Enrollment transfer package" },
    { form_id: "asher_enrollment_transfer", title: "Asher Enrollment transfer" },
    { form_id: "asher_student_referrals", title: "Asher Student Referrals" },
    { form_id: "asher_school_performance_texas", title: "Asher School Performace Texas" },
    { form_id: "asher_main_proposal_form", title: "Asher main Proposal Form" },
    { form_id: "asher_tour_recap", title: "Asher Tour Recap" },
    { form_id: "asher_campus_hours", title: "Asher Campus Hours" },
    { form_id: "asher_proposal_form", title: "Asher Proposal Form" },
    { form_id: "asher_free_environment", title: "Asher Free Environment" },
    { form_id: "asher_proposal_package", title: "Asher Proposal Package" },
    {
        form_id: "beonair_financial_aid_estimate_dependent",
        title: "Beonair Financial Aid Estimate Dependent"
    },
    {
        form_id: "beonair_financial_aid_estimate_independent",
        title: "Beonair Financial Aid Estimate Independent"
    },
    {
        form_id: "bellus_enrollment_agreement_dependent",
        title: "Bellus Enrollment Agreement Dependent"
    },
    {
        form_id: "bellus_enrollment_agreement_independent",
        title: "Bellus Enrollment Agreement Independent"
    },
    {
        form_id: "bellus_optouts",
        title: "Bellus OptOuts"
    },
    {
        form_id: "bellus_enrollment_agreement_form",
        title: "Bellus Enrollment Agreement"
    },
    {
        form_id: "vogue_welcome",
        title: "Welcome to Vogue"
    },
    {
        form_id: "vogue_welcome_es",
        title: "Welcome to Vogue ES"
    },
    {
        form_id: "bellus_enrollment_agreement_dependent_562022",
        title: "Enrollment Addendum Dependent 5.6.2022"
    },
    {
        form_id: "bellus_enrollment_agreement_independent_562022",
        title: "Enrollment Addendum Independent 5.6.2022"
    },
    {
        form_id: "admissions_follow_up",
        title: "Asher Admissions Follow Up"
    },
    { form_id: "enrollment_packet_4_6", title: "Enrollment Packet Information 4.6" }
];
var IndexPage = (function (_super) {
    __extends(IndexPage, _super);
    function IndexPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexPage.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h1", null, "Forms: 11"),
            items.map(function (item, index) {
                return (React.createElement(Li, { title: item.title, form_id: item.form_id, index: index, key: index }));
            })));
    };
    return IndexPage;
}(react_1.Component));
exports.IndexPage = IndexPage;
function Li(_a) {
    var index = _a.index, form_id = _a.form_id, title = _a.title;
    var url = "/?form_id=" + form_id;
    var pdf_url = url + "&pdf";
    return (React.createElement("div", { style: { marginBottom: "10px" } },
        React.createElement("strong", null,
            index + 1,
            ". "),
        React.createElement("a", { href: url }, title),
        " (",
        React.createElement("a", { href: pdf_url }, "PDF"),
        ")"));
}
//# sourceMappingURL=data:application/json;base64,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